import { useEffect, useRef, useState } from "react";
import uploadicon from "../images/upload-icon.svg";
import { LoadPanel, Toast } from "devextreme-react";
import { AppListFunction } from "../pages/Dashboard/AppList/AppListFunction";
import { ViewProductFunction } from "../pages/Dashboard/ViewProduct/ViewProductFunction";
import { DashboardFunction } from "../pages/Dashboard/DashboardFunction";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

export const CreateEditApp = ({
  setcraeteAppShow,
  craeteAppShow,
  type,
  viewData,
  GetProduct,
  setDAta,
}) => {
  const clas = new AppListFunction();
  const clas2 = new ViewProductFunction();
  const clas3 = new DashboardFunction();
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);
  const [field, setField] = useState({
    AppName: viewData?.app_name ? viewData?.app_name : "",
    "Privacy Policy URL": viewData?.privay_policy_url
      ? viewData?.privay_policy_url
      : "",
    "App Logo": viewData?.app_logo ? viewData?.app_logo : "",
  });
  const [AppNamevalidation, setAppNamevalidation] = useState("");
  const [PrivacyPolicyURLvalidation, setPrivacyPolicyURLvalidation] = useState("");
  const [AppLogovalidation, setAppLogovalidation] = useState("");
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const navigate = useNavigate();
  const [imagedisplay, setimagedisplay] = useState(
    viewData?.app_logo ? viewData?.app_logo : ""
  );
  const dispatch = useDispatch();


  useEffect(() => {
    setField({
      AppName: viewData?.app_name || "",
      "Privacy Policy URL": viewData?.privay_policy_url || "",
      "App Logo": viewData?.app_logo || "",
    });

    if (inputRef.current) {
      inputRef.current.value = "";
    }

    // Update other states
    setimagedisplay(viewData?.app_logo || "");
    setAppNamevalidation("");
    setAppLogovalidation("");
    setPrivacyPolicyURLvalidation("");

  }, [craeteAppShow, viewData]);


  const OnSubmit = () => {
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

    if (field?.AppName.trim()) {
      if (field?.AppName.trim()?.length >= 30) {
        return;
      }
      if (
        field?.["Privacy Policy URL"] &&
        !urlRegex.test(field?.["Privacy Policy URL"])
      ) {
        setPrivacyPolicyURLvalidation("Please enter valid URL.");
        return;
      }
      setAppNamevalidation("");
      setAppLogovalidation("");
      setPrivacyPolicyURLvalidation("");
      const formData = new FormData();
      if (field?.["App Logo"]) {
        formData.append("file", field?.["App Logo"]);
      }
      if (type === 0) {
        if (field?.["App Logo"]) {
          clas3.imageUpload(
            setLoading,
            formData,
            {
              app_name: field?.AppName,
              app_logo: field?.["App Logo"],
              privay_policy_url: field?.["Privacy Policy URL"],
            },
            setToastConfig,
            toastConfig,
            setcraeteAppShow,
            GetProduct,
            viewData,
            type,
            setDAta,
            navigate,
            dispatch
          );
        } else {
          clas.CretaeProduct(
            setLoading,
            {
              app_name: field?.AppName,
              app_logo: field?.["App Logo"],
              privay_policy_url: field?.["Privacy Policy URL"],
            },
            setToastConfig,
            toastConfig,
            setcraeteAppShow,
            GetProduct,
            navigate,
            dispatch
          );
        }
      } else {
        if (typeof field?.["App Logo"] !== "string") {
          clas3.imageUpload(
            setLoading,
            formData,
            {
              app_name: field?.AppName,
              app_logo: field?.["App Logo"],
              privay_policy_url: field?.["Privacy Policy URL"],
              isManageApp: false,
            },
            setToastConfig,
            toastConfig,
            setcraeteAppShow,
            GetProduct,
            viewData,
            type,
            setDAta,
            navigate,
            dispatch
          );
        } else {
          clas2.UpdateProduct(
            setLoading,
            {
              app_name: field?.AppName,
              app_logo: field?.["App Logo"],
              privay_policy_url: field?.["Privacy Policy URL"],
              isManageApp: false,
            },
            setToastConfig,
            toastConfig,
            setcraeteAppShow,
            viewData,
            setDAta,
            dispatch
          );
        }
      }
    } else {
      !field?.AppName.trim() && setAppNamevalidation("Please Enter App Name");
    }

  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e?.dataTransfer.files[0];
    if (!file) {
      return;
    }

    var fileSize = file?.size;
    if (fileSize > 5000000) {
      setAppLogovalidation("Image size must be 5 MB or smaller.");
      inputRef.current.value = "";
      return;
    }

    let a = file?.name;
    if (!(a?.includes("png") || a?.includes("jpeg") || a?.includes("svg"))) {
      setAppLogovalidation("Please add JPEG, PNG or SVG File format only.");
      inputRef.current.value = "";
      return;
    }

    if (file) {
      setAppLogovalidation("");
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const base64String = event.target.result;
          setimagedisplay(base64String);
        };
        reader.readAsDataURL(file);
      }
      setField({
        ...field,
        "App Logo": file,
      });
    }
  };

  return (
    <>
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        position={"top"}
        width={"auto"}
      />
      <div>
        <div className="modal__dialog modal__dialog--sm">
          <div className="modal__content">
            <div className="modal__body">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h2 className="modal__title">{`${type === 0 ? "Create" : "Edit"
                  } An App`}</h2>
                <svg
                  onClick={() => {
                    setcraeteAppShow(false);
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                  width="13"
                  height="13"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.72406 0.282539C9.43156 -0.00996077 8.95906 -0.00996077 8.66656 0.282539L4.99906 3.94254L1.33156 0.275039C1.03906 -0.0174609 0.566563 -0.0174609 0.274063 0.275039C-0.0184375 0.567539 -0.0184375 1.04004 0.274063 1.33254L3.94156 5.00004L0.274063 8.66754C-0.0184375 8.96004 -0.0184375 9.43254 0.274063 9.72504C0.566563 10.0175 1.03906 10.0175 1.33156 9.72504L4.99906 6.05754L8.66656 9.72504C8.95906 10.0175 9.43156 10.0175 9.72406 9.72504C10.0166 9.43254 10.0166 8.96004 9.72406 8.66754L6.05656 5.00004L9.72406 1.33254C10.0091 1.04754 10.0091 0.567539 9.72406 0.282539Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div className="form">
                <div className="form__group">
                  <label className="form__label">App Name</label>
                  <input
                    className="form-control"
                    style={{ border: AppNamevalidation ? "2px solid red" : "" }}
                    value={field?.AppName}
                    onChange={(e) => {
                      if (e.target.value?.trim()?.length > 30) {
                        setAppNamevalidation(
                          "App name not more then 30 characters."
                        );
                      } else {
                        setAppNamevalidation("");
                      }
                      setField({ ...field, AppName: e.target.value });
                    }}
                    name="name"
                    id="name"
                    type="text"
                    placeholder="Enter App Name"
                  />
                  {AppNamevalidation && (
                    <p className="field-error" style={{ marginTop: "5px" }}>
                      {AppNamevalidation}
                    </p>
                  )}
                </div>
                <div style={{ marginTop: "30px" }} className="form__group">
                  <label className="form__label">Webhook URL</label>
                  <input
                    className="form-control"
                    style={{
                      border: PrivacyPolicyURLvalidation ? "2px solid red" : "",
                    }}
                    name="url"
                    id="url"
                    type="url"
                    placeholder="Enter Webhook URL"
                    value={field?.["Privacy Policy URL"]}
                    onChange={(e) => {
                      setPrivacyPolicyURLvalidation("");
                      setField({
                        ...field,
                        "Privacy Policy URL": e.target.value,
                      });
                    }}
                  />
                  {PrivacyPolicyURLvalidation && (
                    <p className="field-error" style={{ marginTop: "5px" }}>
                      {PrivacyPolicyURLvalidation}
                    </p>
                  )}
                </div>
                <div style={{ marginTop: "30px" }} className="form__group">
                  <label className="form__label">App Logo</label>
                  <div
                    onDragOver={(e) => {
                      handleDragOver(e);
                    }}
                    onDrop={(e) => {
                      handleDrop(e);
                    }}
                    className="form__uploadbox"
                  >
                    <input
                      ref={inputRef}
                      className="form__input form__input--hidden"
                      name="name"
                      id="uploadappLogo"
                      accept=".jpeg, .png, .svg "
                      type="file"
                      onChange={(e) => {
                        const file = e?.target?.files[0];

                        if (file) {
                          var fileSize = file?.size;
                          if (fileSize > 5000000) {
                            setAppLogovalidation(
                              "Image size must be 5 MB or smaller."
                            );
                            inputRef.current.value = "";
                            return;
                          }

                          let a = file?.name;
                          if (
                            !(
                              a?.includes("png") ||
                              a?.includes("jpeg") ||
                              a?.includes("svg")
                            )
                          ) {
                            setAppLogovalidation(
                              "Please add JPEG, PNG or SVG File format only."
                            );
                            inputRef.current.value = "";
                            return;
                          }

                          setAppLogovalidation("");
                          if (file) {
                            const reader = new FileReader();
                            reader.onload = (event) => {
                              const base64String = event.target.result;
                              setimagedisplay(base64String);
                            };
                            reader.readAsDataURL(file);
                          }
                          setField({
                            ...field,
                            "App Logo": file,
                          });
                        }
                      }}
                    />
                    <label className="form__browsefile" htmlFor="uploadappLogo">
                      {!imagedisplay && (
                        <>
                          <span className="iconbox">
                            <img src={uploadicon} alt="upload icon" />
                          </span>
                          <span className="title">Drag files to upload</span>
                          <p className="ortext">or</p>
                          <span className="btnBrowse">Browse Files</span>
                        </>
                      )}
                      <img
                        style={{
                          width: "80px",
                          height: "90px",
                          objectFit: "cover",
                          display: imagedisplay ? "block" : "none",
                          marginTop: "-8px",
                          marginBottom: "8px",
                        }}
                        alt="display icon"
                        src={imagedisplay}
                        className="participate_block1_sub1_div_imag"
                      />

                      <p className="para">
                        Max File Size: <strong>05 MB</strong> <br />
                        Supported file type: <strong>JPEG, PNG, SVG</strong>
                      </p>
                    </label>
                  </div>

                  {AppLogovalidation && (
                    <p className="field-error" style={{ marginTop: "-25px" }}>
                      {AppLogovalidation}
                    </p>
                  )}
                </div>
              </div>
              <div className="form__group form__group--btnflex">
                <button
                  className="btn btn--primary"
                  onClick={() => {
                    OnSubmit();
                  }}
                >
                  {type === 0 ? "Create App" : "Update App"}
                </button>
                <button
                  onClick={() => {
                    setcraeteAppShow(false);
                  }}
                  className="btn btn--grayOutline"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
